<template>
  <b-breadcrumb :items="breadcrumb" />
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    breadcrumb () {
      return [ { text: (this.isA('client') ? 'Minha conta' : 'Painel'), to: '/painel' }].concat(this.items)
    }
  }
};
</script>
